import React from 'react';

import { Grid, Typography } from '@mui/material';
import {
  FormPublicDesignFragment,
  FormPublicFieldFragment,
} from 'graphql/fragment/form.public.fragment';
import { StyledButton } from './styled/button';
import styled from 'styled-components';

interface Props {
  field: FormPublicFieldFragment;
  design: FormPublicDesignFragment;
  lastSlideIndex: number;
  prev: () => void;
  next: (values?: any) => void;
  values: any;
  errors: any;
  slideIndex: number;
  buttonText?: string;
  buttonWidth?: string;
}

/**
 * @param input email input
 * @returns if the input is an email
 */
export const isEmail = (input: string): boolean => {
  let emailRE =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return emailRE.test(input);
};

export const BottomNavigation: React.FC<Props> = ({
  prev,
  slideIndex,
  design,
  field,
  values,
  next,
  errors,
  lastSlideIndex,
  buttonText = 'Next',
  buttonWidth,
}) => {
  return (
    <Grid
      container
      direction='row'
      justifyContent='space-between'
      alignItems='center'
      maxWidth='xl'
      sx={{ zIndex: 1000 }}
    >
      <Grid justifyContent='end' item xs={6}>
        {slideIndex !== 0 ? (
          <StyledButton
            type='submit'
            onClick={prev}
            background={design.colors.background}
            $buttonColor={design.colors.button}
            highlight={design.colors.buttonActive}
          >
            Back
          </StyledButton>
        ) : null}
      </Grid>
      <Grid display='flex' justifyContent='end' item xs={6}>
        <StyledButton
          type='submit'
          disabled={field.required && !values[field.id]}
          onClick={() => {
            if (lastSlideIndex === slideIndex) {
              return;
            }
            if (field.required && values[field.id]) {
              if (field.type === 'email' && isEmail(values[field.id])) {
                // if field is an email validate it is an email input before allowing user to move to next step
                next();
              } else if (
                field.type === 'textarea' ||
                field.type === 'textfield'
              ) {
                if (!errors[field.id]) {
                  next();
                }
              } else if (field.type !== 'email') {
                // TODO: had to hardcode this for now will think of better solution later
                next(values);
              }
              // if field is required and values are not null then allow user to move to step
            } else if (!field.required) {
              // if field is not required then allow user to move to next step
              next();
            }
          }}
          background={design.colors.button}
          $buttonColor={design.colors.buttonText}
          highlight={design.colors.buttonActive}
          width={buttonWidth}
        >
          {lastSlideIndex === slideIndex ? 'Submit' : buttonText}
        </StyledButton>
      </Grid>
    </Grid>
  );
};
